module.exports = __webpack_public_path__ + "img/8f97729.webp";